import React from 'react'
import { CSVLink } from 'react-csv'
// import Button from 'react-bootstrap/Button';

export const ExportReactCSV = ({ csvData, fileName }) => {
    return (
        <button variant="warning float-right">
            <CSVLink data={csvData} filename={fileName}>
                <i className="fas fa-file-excel"></i>
                Export
            </CSVLink>
        </button>
    )
}